import gsap from "gsap";
import variables from '../../../../variables';
import vars from './vars';
import ScrollTrigger from 'gsap/ScrollTrigger';
import {$dom} from '../../../../helpers/dom';
import {$style} from '../../../../helpers/style';
import {$events} from '../../../../helpers/events';
import SmoothScrollbar from 'smooth-scrollbar';
import {Scrollbar} from 'smooth-scrollbar/scrollbar';

gsap.registerPlugin(ScrollTrigger);

const {
	get
} = $dom;

const {
	offset
} = $style;

const {
	asideSelector,
	asideWrapperSelector,
	paginationSelector,
	scrollbarNeedUpdateEventName
} = vars;

const {
	header,
	footer
} = variables.dom;

const scrollbarPaddingRight = 20;

export default function catalogStickyAside() {

	let aside, asideWrapper, pagination, asideWrapScrollbar, stickyScrollTrigger;

	function updateScrollBar({detail}) {
		if(asideWrapScrollbar instanceof Scrollbar) {
			const {direction} = detail;

			switch (direction) {
				case 'up':
					asideWrapScrollbar
						.scrollTo(0, 0, variables.gsapDefaultDuration * 1000, {callback: asideWrapScrollbar.update});
					break;

				case 'down':
					asideWrapScrollbar.update();
					break;
			}
		}
	}

	function setView() {
		aside = get(asideSelector);
		asideWrapper = get(asideWrapperSelector);
		pagination = get(paginationSelector);

		gsap.set(asideWrapper, {
			clearProps: 'maxHeight,height,overflow,paddingRight'
		});

		const
			asideInitialTopOffset = offset(aside).top,
			asideHeaderOffset = header.offsetHeight * 1.25,
			paginationOffset = pagination.offsetHeight * 1.5,
			asideWrapperMaxHeight = Math.ceil(variables.windowHeight - (asideHeaderOffset + paginationOffset))
		;

		if (variables.windowWidth > variables.breakpoints.lg) {

			gsap.set(asideWrapper, {
				maxHeight: asideWrapperMaxHeight + 'px',
				height: asideWrapperMaxHeight + 'px',
				overflow: 'auto',
				paddingRight: `${scrollbarPaddingRight}px`
			});

			stickyScrollTrigger = ScrollTrigger.create({
				trigger: variables.selectors.pageWrapper,
				start: `+=${asideInitialTopOffset - asideHeaderOffset} top`,
				end: `bottom-=${footer.offsetHeight} bottom`,
				pin: asideWrapper
			});


			asideWrapScrollbar = SmoothScrollbar.init(asideWrapper, variables.scrollbarDefaults);
			SmoothScrollbar.detachStyle();

		} else {

			if(stickyScrollTrigger instanceof ScrollTrigger) stickyScrollTrigger.kill();
			if(asideWrapScrollbar instanceof Scrollbar) asideWrapScrollbar.destroy();

		}


	}

	const
		init = () => {
			setView();
			$events.resize('on', setView);
			$events.delegate.on(scrollbarNeedUpdateEventName, document, updateScrollBar)
		},
		destroy = () => {
			aside = null;
			asideWrapper = null;
			asideWrapScrollbar.destroy();
			$events.resize('off', setView);
			$events.delegate.off(scrollbarNeedUpdateEventName, document, updateScrollBar)
		}
	;

	return {init, destroy}
}
